module.exports = __webpack_public_path__ + "public/Icons/tonePause.svg?c37ab7ed";